import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PaymentMethods = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl space-y-6">
      <div className="bg-white rounded-lg border border-border overflow-hidden">
        <div className="px-6 py-4 border-b border-border">
          <h2 className="text-lg font-semibold text-foreground">Payment Methods</h2>
          <p className="text-sm text-muted-foreground mt-1">
            How payments are handled on your account.
          </p>
        </div>

        <div className="p-6 space-y-6">
          <div className="flex items-start gap-4 p-4 rounded-lg border border-border bg-accent/10">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="CreditCard" size={20} className="text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-foreground mb-1">Cards are entered at checkout</h3>
              <p className="text-sm text-muted-foreground">
                For your safety, Bounderlaster doesn't store your card details on your account.
                Each time you check out, you'll enter your card on Stripe's secure form. You can
                choose to save it for next time directly from that screen.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="flex items-start gap-3 p-4 rounded-lg border border-border">
              <Icon name="Lock" size={18} className="text-primary mt-0.5" />
              <div>
                <p className="font-medium text-foreground text-sm">Encrypted by Stripe</p>
                <p className="text-xs text-muted-foreground mt-1">
                  Card details never touch Bounderlaster's servers.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-lg border border-border">
              <Icon name="ShieldCheck" size={18} className="text-primary mt-0.5" />
              <div>
                <p className="font-medium text-foreground text-sm">PCI compliant</p>
                <p className="text-xs text-muted-foreground mt-1">
                  Payments handled by a certified Level&nbsp;1 provider.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-lg border border-border">
              <Icon name="RefreshCw" size={18} className="text-primary mt-0.5" />
              <div>
                <p className="font-medium text-foreground text-sm">Refunds back to source</p>
                <p className="text-xs text-muted-foreground mt-1">
                  Refunds go to the same card used for the purchase.
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between p-4 rounded-lg border border-border">
            <div>
              <p className="font-medium text-foreground">Ready to shop?</p>
              <p className="text-sm text-muted-foreground">
                Add items to your cart and we'll walk you through secure checkout.
              </p>
            </div>
            <Button onClick={() => navigate('/product-catalog')} iconName="ShoppingBag" iconPosition="left">
              Browse Products
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
